<table class="imc-table">
  <thead> <!-- class="text-menu-title-selected" -->
    <tr>
      <th rowspan="2" class="tw-align-bottom">Estado</th>
      <th rowspan="2" class="tw-align-bottom">IMC</th>
    </tr>

  </thead>
  <tbody>
    <tr>
      <td class="text-center" [class.selected]="imcValue < 18.5">Peso bajo</td>
      <td class="text-center" [class.selected]="imcValue < 18.5">< 18.5</td>
    </tr>
    <tr>
      <td class="text-center" [class.selected]="imcValue >=18.5 && imcValue < 25">Peso normal</td>
      <td class="text-center" [class.selected]="imcValue >=18.5 && imcValue < 25">18.5 - 24.9</td>
    </tr>
    <tr>
      <td class="text-center" [class.selected]="imcValue >=25 && imcValue < 30">Sobrepeso</td>
      <td class="text-center" [class.selected]="imcValue >=25 && imcValue < 30">25.0 - 29.9</td>
    </tr>
    <tr>
      <td class="text-center" [class.selected]="imcValue >=30 && imcValue < 34.9">Obesidad clase I</td>
      <td class="text-center" [class.selected]="imcValue >=30 && imcValue < 34.9">30.0 - 34.9</td>
    </tr>
    <tr>
      <td class="text-center" [class.selected]="imcValue >=35 && imcValue < 39.9">Obesidad clase II</td>
      <td class="text-center" [class.selected]="imcValue >=35 && imcValue < 39.9">35.0 - 39.9</td>
    </tr>
    <tr>
      <td class="text-center" [class.selected]="imcValue >=40">Obesidad clase III</td>
      <td class="text-center" [class.selected]="imcValue >=40"> >= 40 </td>
    </tr>
  </tbody>
</table>

<div class="tw-pt-4 tw-flex tw-items-center">
  <span nz-icon nzType="link" nzTheme="outline"></span>
  <a class="tw-ml-1" target="_blank" href="https://www.euro.who.int/en/health-topics/disease-prevention/nutrition/a-healthy-lifestyle/body-mass-index-bmi">Referencia - Tabla IMC - OMS</a>
</div>
